"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCard = getCard;
exports.getCardOrThrow = getCardOrThrow;
exports.getCards = getCards;
exports.byType = byType;
exports.byModule = byModule;
const cardJson = require("@/genfiles/cards.json");
const cards = new Map();
const cardArray = [];
function getCard(cardName) {
    return cards.get(cardName);
}
function getCardOrThrow(cardName) {
    const card = getCard(cardName);
    if (card === undefined) {
        throw new Error(`card not found ${cardName}`);
    }
    return card;
}
function getCards(filter) {
    return cardArray.filter(filter);
}
function byType(cardType) {
    return (card) => card.type === cardType;
}
function byModule(module) {
    return (card) => card.module === module;
}
function initialize() {
    cardJson.forEach((card) => {
        cards.set(card.name, card);
        cardArray.push(card);
    });
}
initialize();
